import React from "react";

function NuitDeLinfoProject(props: any) : JSX.Element{
    return <><iframe src="https://giphy.com/embed/3og0IGLKtngri8G5pK" width="480" height="360" frameBorder="0" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/time-watch-3og0IGLKtngri8G5pK">via GIPHY</a></p></>;
}

export default NuitDeLinfoProject;